import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * Slot recipe for the teaser-only level-3 pane of the flyout navigation.
 */
export const flyoutNavigationLevel3TeasersRecipe = defineSlotRecipe({
    className: 'flyout-navigation-level3-teasers',
    slots: ['root', 'teaserOnly', 'teaserOnlyItems', 'teaserOnlyItem'],
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            // The same breadcrumb seam the standard pane draws, so the two
            // level-3 shapes start their content on the same line.
            gap: 'spacing-12'
        },
        teaserOnly: {
            width: 'full'
        },
        teaserOnlyItems: {
            display: 'grid',
            gridTemplateColumns: {base: '1fr', s: 'repeat(4, minmax(0, 1fr))'},
            gap: {base: 'spacing-8', s: 'spacing-12'},
            listStyleType: 'none',
            margin: 0,
            padding: 0,
            _empty: {
                display: 'none'
            }
        },
        teaserOnlyItem: {
            minWidth: 0,
            height: 'auto'
        }
    }
})
